import { call, takeEvery, put } from 'redux-saga/effects';
import {
  dadataSearch,
  dadataSearchSuccess,
  dadataSearchFailure,
} from '../../actions/daData';

import { dadataRequest } from '../../../api/requests/daData';

function* dadataSaga(action) {
  try {
    const { payload } = action;
    const response = yield call(dadataRequest, payload);
    if (response.data.suggestions.length) {
      yield put(dadataSearchSuccess(response.data.suggestions));
    } else {
      throw response;
    }
  } catch (error) {
    yield put(dadataSearchFailure(error));
  }
}

export function* dadataWatcher() {
  yield takeEvery(dadataSearch.toString(), dadataSaga);
}
